<template>
  <div id="tabbable-som" class="tabbable tabs-left">
    <ul id="tab-somministrations" class="nav nav-tabs scrollable">
      <li
        :key="index"
        v-for="(guest, index) in guests"
        :class="['somm--tab-guest', alertSommClass(guest), { active: selected === guest }, { disabled: guestInPreparation }]"
        @click="() => loadPreparation(guest)"
      >
        <slot v-bind="guest"></slot>
      </li>
    </ul>
    <div class="tab-content tab-content-right">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tabPreparations',
  props: ['guests', 'selected'],
  data() {
    return {
      guestInPreparation: false,
    };
  },
  methods: {
    loadPreparation(guest) {
      if (!this.guestInPreparation) {
        this.$parent.$emit('guestSelected', guest);
      }
    },
    alertSommClass(guest) {
      // all_drugs == 0 => terapia AB
      if (!guest.all_drugs || guest.all_drugs === 0) return '';
      if (guest.done_drugs == guest.all_drugs) return 'all_done';
      if (guest.done_with_variations > 0 || guest.all_drugs - guest.done_drugs < guest.all_drugs) return 'some_done';
      return 'none_done';
    },
  },
  mounted() {
    eventBus.$on('toggleAlertTherapy', (guest_period_data_set_id, done, doneWithVariations) => {
      let guest = this.guests.find((item) => item.id === guest_period_data_set_id),
        index = this.guests.indexOf(guest);
      guest['done_drugs'] = done;
      guest['done_with_variations'] = doneWithVariations;
      this.$set(this.guests, index, guest);
    });

    eventBus.$on('guestInPreparation', (guestInPreparation) => {
      this.guestInPreparation = guestInPreparation;
    });
  },
};
</script>
<style lang="scss" scoped>
.scrollable {
  max-height: 600px;
  overflow-y: scroll;
}
#tab-somministrations {
  width: 250px;
}
li.somm--tab-guest {
  border-radius: 5px 0 0 5px;
  & > a {
    padding: 6px 8px;
  }
  &.all_done {
    border-left: 5px solid #0b0;
  }
  &.none_done {
    border-left: 5px solid red;
  }
  &.some_done {
    border-left: 5px solid orange;
  }
}
</style>
